/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CompanyJobSubFamily } from '../models/CompanyJobSubFamily';
import type { CompanyJobSubFamilySort } from '../models/CompanyJobSubFamilySort';
import type { CreateCompanyJobSubFamilyRequest } from '../models/CreateCompanyJobSubFamilyRequest';
import type { UpdateCompanyJobSubFamilyRequest } from '../models/UpdateCompanyJobSubFamilyRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class CompanyJobSubFamilyService {

    /**
     * Get company job sub families
     * @returns CompanyJobSubFamily Success
     * @throws ApiError
     */
    public static getCompanyJobSubFamily({
        limit,
        offset,
        ignorePagination,
        search,
        jobFamilyId,
        sort,
    }: {
        /**
         * Pagination Limit
         */
        limit?: number,
        /**
         * Pagination Offset
         */
        offset?: number,
        /**
         * Ignore pagination
         */
        ignorePagination?: boolean,
        /**
         * Search
         */
        search?: string,
        /**
         * Job family id
         */
        jobFamilyId?: number,
        sort?: CompanyJobSubFamilySort,
    }): CancelablePromise<Array<CompanyJobSubFamily>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/jobFamily/subFamily',
            query: {
                'limit': limit,
                'offset': offset,
                'ignorePagination': ignorePagination,
                'search': search,
                'jobFamilyId': jobFamilyId,
                'sort': sort,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Create company job sub family
     * @returns CompanyJobSubFamily Success
     * @throws ApiError
     */
    public static createCompanyJobSubFamily({
        requestBody,
    }: {
        requestBody: CreateCompanyJobSubFamilyRequest,
    }): CancelablePromise<CompanyJobSubFamily> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/jobFamily/subFamily',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Delete company job sub families
     * @returns any Success
     * @throws ApiError
     */
    public static deleteCompanyJobSubFamilies({
        jobSubFamilyIds,
    }: {
        /**
         * Job Sub Family Ids To Delete
         */
        jobSubFamilyIds?: Array<number>,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/jobFamily/subFamily',
            query: {
                'jobSubFamilyIds': jobSubFamilyIds,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }

    /**
     * Update company job sub family
     * @returns CompanyJobSubFamily Success
     * @throws ApiError
     */
    public static updateCompanyJobSubFamily({
        id,
        requestBody,
    }: {
        /**
         * Company job sub family id
         */
        id: number,
        requestBody: UpdateCompanyJobSubFamilyRequest,
    }): CancelablePromise<CompanyJobSubFamily> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/jobFamily/subFamily/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Delete company job sub family
     * @returns any Success
     * @throws ApiError
     */
    public static deleteCompanyJobSubFamily({
        id,
    }: {
        /**
         * Company job sub family id
         */
        id: number,
    }): CancelablePromise<{
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/jobFamily/subFamily/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

}
